const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'ship2',
  tiles: {
    ceiling: 0,
    door: 1,
    floor: 2,
    medkit: 3,
    note: 4,
    secret: 5,
    sink: 6,
    solid1: 7,
    solid2: 8,
    solid3: 9,
    stairs_down: 10,
    stairs_up: 11,
    terminal1: 12,
    terminal2: 13,
    terminal3: 14,
    terminal4: 15,
    terminal5: 16,
    window_low: 17,
    window1: 18
  },
  uidata: {
    rects: [
      vec4(8/1024,8/64,40/1024,40/64),
      vec4(56/1024,8/64,88/1024,40/64),
      vec4(104/1024,8/64,136/1024,40/64),
      vec4(152/1024,8/64,184/1024,40/64),
      vec4(200/1024,8/64,232/1024,40/64),
      vec4(248/1024,8/64,280/1024,40/64),
      vec4(296/1024,8/64,328/1024,40/64),
      vec4(344/1024,8/64,376/1024,40/64),
      vec4(392/1024,8/64,424/1024,40/64),
      vec4(440/1024,8/64,472/1024,40/64),
      vec4(488/1024,8/64,520/1024,40/64),
      vec4(536/1024,8/64,568/1024,40/64),
      vec4(584/1024,8/64,616/1024,40/64),
      vec4(632/1024,8/64,664/1024,40/64),
      vec4(680/1024,8/64,712/1024,40/64),
      vec4(728/1024,8/64,760/1024,40/64),
      vec4(776/1024,8/64,808/1024,40/64),
      vec4(824/1024,8/64,856/1024,40/64),
      vec4(872/1024,8/64,904/1024,40/64)
    ]
  },
  FRAME_CEILING: 0,
  FRAME_DOOR: 1,
  FRAME_FLOOR: 2,
  FRAME_MEDKIT: 3,
  FRAME_NOTE: 4,
  FRAME_SECRET: 5,
  FRAME_SINK: 6,
  FRAME_SOLID1: 7,
  FRAME_SOLID2: 8,
  FRAME_SOLID3: 9,
  FRAME_STAIRS_DOWN: 10,
  FRAME_STAIRS_UP: 11,
  FRAME_TERMINAL1: 12,
  FRAME_TERMINAL2: 13,
  FRAME_TERMINAL3: 14,
  FRAME_TERMINAL4: 15,
  FRAME_TERMINAL5: 16,
  FRAME_WINDOW_LOW: 17,
  FRAME_WINDOW1: 18
};
spritesheetRegister(module.exports);
